module.exports = __webpack_public_path__ + "img/image002.29cdaad5.jpg";